import { Stack, Typography } from "@mui/material";
import { Controller } from "react-hook-form";
import OutlinedText from "components/Input/OutlinedText/OutlinedText";
import React from "react";
import { CustomComponentCommonProps, rules } from "../utils";
import { useTranslation } from "react-i18next";
const AccountInfoSession = ({ control, isEdit, isLoading }) => {
  const { t } = useTranslation();
  const PAGE_LOCALE_KEY = "page.merchants.";
  const FORM_LABEL_KEY =
    PAGE_LOCALE_KEY + "merchantDetail.info.accountInfo.fields";
  return (
    <Stack direction={"column"} rowGap={2} width={"80%"}>
      <Typography variant="h3">
        {t(`${PAGE_LOCALE_KEY}merchantDetail.info.accountInfo.title`)}
      </Typography>
      <Stack direction={"row"} gap={2} flexWrap={"wrap"}>
        <Controller
          name="bankAccount"
          control={control}
          defaultValue=""
          rules={rules({
            validationTags: ["validBankAccount"],
          })}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <OutlinedText
              errorMessage={error?.message || ""} // Show actual error message
              onchangeFn={onChange}
              divStyle={{ flexGrow: 1, flexBasis: "600px" }}
              sxParams={{
                textError: !!error,
              }}
              {...CustomComponentCommonProps(
                t(`${FORM_LABEL_KEY}.bankAccount`),
                value,
                "OutlinedText",
                false,
                isEdit,
                isLoading
              )}
            />
          )}
        />
        <Controller
          name="beneficiary"
          control={control}
          defaultValue=""
          rules={rules({
            maxLength: 140,
            validationTags: [
              "onlyBlockLetter",
              "noLeadingWhitespace",
              "validBankBeneficiary",
            ],
          })}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <OutlinedText
              errorMessage={error?.message || ""}
              onchangeFn={onChange}
              divStyle={{ flexGrow: 1, flexBasis: "600px" }}
              sxParams={{
                textError: !!error,
              }}
              {...CustomComponentCommonProps(
                t(`${FORM_LABEL_KEY}.beneficiary`),
                value,
                "OutlinedText",
                false,
                isEdit,
                isLoading
              )}
            />
          )}
        />
        <Controller
          name="bankAccountRemarks"
          control={control}
          defaultValue=""
          rules={rules({
            maxLength: 255,
            validationTags: ["noLeadingWhitespace", "noQuotesOrBackticks"],
          })}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <OutlinedText
              errorMessage={error?.message || ""}
              onchangeFn={onChange}
              divStyle={{ flexGrow: 1, flexBasis: "600px" }}
              {...CustomComponentCommonProps(
                t(`${FORM_LABEL_KEY}.bankAccountRemarks`),
                value,
                "OutlinedText",
                false,
                isEdit,
                isLoading
              )}
              sxParams={{
                textError: !!error,
              }}
            />
          )}
        />
      </Stack>
    </Stack>
  );
};
export default React.memo(AccountInfoSession);
